import React from 'react';
import glamorous from 'glamorous';
import FeatureCard from './index';
import {PHONE, TABLET} from '../../../../shared/style/breakpoints';

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: 1080,
  justifyContent: 'space-evenly',
  position: 'relative',
  marginTop: 341,
  [TABLET]: {
    marginTop: 850
  },
  [PHONE]: {
    width: '85%',
    marginTop: 300,
    marginBottom: 66
  }
});

const features = [
  {
    icon: 'https://img.stackshare.io/fe/private/track-updates.svg',
    title: 'Stop tech sprawl. Empower everyone to make data-driven technology decisions',
    subTitle: 'Make your technology usage visible',
    description:
      'Individual developers often have no way of knowing what other teams have done to solve similar problems. StackShare Enterprise gives everyone a single source of truth around which solutions are in use, so your teams can move forward with confidence.',
    showPoints: true,
    image: 'https://img.stackshare.io/fe/private/dashboard_graphic_2x.png',
    caption:
      '<strong>Dashboard</strong> - see all the technologies you’re using across all your Git repos in one view',
    captionStyle: {},
    maxImageSize: 900,
    points: [
      'Discover and share commonalities',
      'Break down engineering silos',
      'Avoid duplication of efforts',
      'Enhance collaboration',
      'Prevent tech debt'
    ],
    testimonial: {
      image: 'https://img.stackshare.io/fe/landing/author_image2.svg',
      text:
        'StackShare has saved us hundreds of hours compiling, maintaining, and updating information on our stacks. We can now track it all in real time. StackShare’s transparency into our applications has been a big help in improving the overall knowledge flow across the company.',
      name: 'Chris Cummings, ',
      position: 'Senior Director of Architecture, Tyler Technologies'
    }
  },
  {
    icon: 'https://img.stackshare.io/fe/private/tech-sprawl.svg',
    title: 'Track updates across all your stacks in real time',
    subTitle: '',
    description:
      'The larger and more complex your tech stack footprint, the harder it is to track ongoing changes using manual processes or traditional tools. StackShare Enterprise automates stack monitoring, sending you real-time alerts with complete, accurate, timely data.',
    showPoints: true,
    image: 'https://img.stackshare.io/fe/private/alerts_graphic_slack_2x.png',
    caption:
      '<strong>Stack Alerts</strong> - get realtime updates on tool additions/removals and upgrades',
    captionStyle: {marginRight: 40},
    maxImageSize: 750,
    points: [
      'Automatically document and share stack decisions',
      'Know the who/what/when of all stack changes',
      'See stack change alerts in Slack/MS Teams',
      'Simplify stack profile monitoring',
      'See updates in pull requests'
    ],
    testimonial: {
      image: 'https://img.stackshare.io/fe/private/evan.png',
      text:
        'Integration was a breeze- we were up and running in a matter of minutes… we have a lot of engineers in the StackShare Slack channel. It lets us see stack changes like minor/major version bumps being made across all of our repos in real-time, before any other tools surface them.',
      name: 'Evan Robinson, ',
      position: 'VP of Engineering, AxleHire'
    }
  },
  {
    icon: 'https://img.stackshare.io/fe/private/consolidate-tech.svg',
    title: 'Consolidate technologies and improve governance',
    subTitle: '',
    description:
      'Multiple versions of competing technologies can fragment expertise, expand vulnerabilities, and inhibit innovation. StackShare Enterprise enables you to manage approved technologies, including versions, so you can more easily execute your technical vision. ',
    showPoints: true,
    image: 'https://img.stackshare.io/fe/private/report_graphic_2x.png',
    caption:
      '<strong>Tools Report</strong> - query and filter against all the tools in all your repos in one view',
    captionStyle: {},
    maxImageSize: 900,
    points: [
      'Consolidate versions, tools, stacks, and supply chains',
      'Provide autonomy with guardrails',
      'Improve security and compliance',
      'Boost team speed and innovation',
      'Tool lifecycle management '
    ],
    testimonial: {
      image: 'https://img.stackshare.io/fe/landing/author_image1.svg',
      text:
        'We now have visibility into the technologies in use across the company and we can proactively manage adoption and retirement. We can have oversight without having a heavy hand in making decisions for everyone.',
      name: 'Jeff Green, ',
      position: 'CTO, Tyler Technologies'
    }
  }
];

const Features = () => {
  return (
    <Container>
      {features.map((feature, index) => (
        <FeatureCard key={index} feature={feature} />
      ))}
    </Container>
  );
};

export default Features;
